module.exports = __webpack_public_path__ + "img/binhai.1fa86fc1.png";